import { useGetPaginatedAnnouncesWithCriteria } from '@/components/Search/hooks/queries';
import { SearchFiltersSortDebounceType } from '@/components/Search/types';

const useFetchAnnounces = ({
  filters,
  sort,
  onFetch = () => {},
}: SearchFiltersSortDebounceType & { onFetch: () => void }) => {
  const {
    announces,
    fetchNextPage,
    hasMore,
    isFetching,
    isError,
    isLoading,
    totalCount,
    currentPage,
  } = useGetPaginatedAnnouncesWithCriteria({
    filters,
    sort,
    onFetch,
  });

  return {
    announces,
    fetchMore: fetchNextPage,
    totalCount,
    currentPage,
    hasMore,
    isFetching,
    isLoading,
    isError,
  };
};

export default useFetchAnnounces;
